<!--
  The content of the failed-payment message, not a modal in its own right, as SuccessModal.

  This used to wrap itself in its own ModalView, bound to an isModalVisible prop that none of
  its callers passed: each renders it in a ModalView of its own. So the inner modal never
  rendered and a failed payment showed a "Payment" header over nothing. It also always said
  "Your Card Number Is Incomplete", whatever had gone wrong.
-->
<template>
  <div class="form-checkout-container d-flex justify-content-center align-items-center flex-column padding-5">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img src="../../../../assets/failed.svg" class="gap-4" alt="" />
      <p class="font-failed">Payment failed</p>
      <p class="order-font">
        We couldn't take your payment. Please check your card details and try again, or contact
        help@livingdna.com if it keeps happening.
      </p>
    </div>
    <div class="failed-actions">
      <button class="ldna-btn" @click="$emit('close')">Close</button>
    </div>
  </div>
</template>

<script>
import "../../../../styles/pages/BloodTestDetails.scss";
import { defineComponent } from "vue";

export default defineComponent({
  name: 'FailedModal',
  emits: ['close'],
});
</script>

<style scoped>
.failed-actions {
  width: 100%;
  max-width: 320px;
  margin-top: 24px;
}
</style>
